import { render } from "./PaginationG.vue?vue&type=template&id=4e6fc8f2"
import script from "./PaginationG.vue?vue&type=script&lang=js"
export * from "./PaginationG.vue?vue&type=script&lang=js"

import "./PaginationG.vue?vue&type=style&index=0&id=4e6fc8f2&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__